import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductCpuService } from '../../../services/product-cpu.service';

@Component({
  selector: 'app-view-product-cpus',
  templateUrl: './view-product-cpus.component.html',
  styleUrls: ['./view-product-cpus.component.css'],
  providers:[ProductCpuService]
})
export class ViewProductCpusComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  productCpu: any = {
    laptops: false,
    consoles: false,
    products: false,
    mobiles: false
  };
  constructor(private productCpuService:ProductCpuService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      if (params['id'] !== undefined){
        this.id = params['id'];
        this.getProductCpu();
      }
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getProductCpu(){
    this.productCpuService.get(this.id).subscribe((productCpu) => {
      this.productCpu = productCpu;
    });
  }
  

  saveProductCpu(){
    this.parseProductsType();
    if (this.productCpu.id == undefined){
      this.productCpuService.create(this.returnProductCpuProperties(this.productCpu))
      .subscribe((productCpu) => {
        this.productCpuService.get(productCpu.id).subscribe((productCpu) => {
          this.productCpu = productCpu;
          this.router.navigate(['/configuration/productcpus']);
        });
      });
    }else{
      this.productCpuService.update(this.returnProductCpuProperties(this.productCpu))
      .subscribe((productCpu) => {
        this.productCpu = productCpu;
      });
    }
  }

  returnProductCpuProperties(productCpu){
    var properties = {
      name: productCpu.name,
      product_types: productCpu.product_types
    }
    if (productCpu.id){
      properties['id'] = productCpu.id;
    }
    return properties;
  }

  parseProductsType(){
    this.productCpu.product_types = "";
    if(this.productCpu.mobiles === true){
      this.productCpu.product_types += "1,";
    }
    if(this.productCpu.consoles === true){
      this.productCpu.product_types += "2,";
    }
    if(this.productCpu.products === true){
      this.productCpu.product_types += "3,";
    }
    if(this.productCpu.laptops === true){
      this.productCpu.product_types += "4,";
    }
    this.productCpu.product_types = this.productCpu.product_types.substring(0,this.productCpu.product_types.length - 1);
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/product-cpus/view-product-cpus/view-product-cpus.component.ts